import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, alpha, Container, OutlinedInput, InputAdornment, Link, Typography } from '@material-ui/core';
//
import { varFadeInUp, TextAnimate, MotionInView, varWrapEnter, varFadeInRight, varFadeInDown } from '../../animate';
import { Helmet } from 'react-helmet';

// ----------------------------------------------------------------------

const RootStyle = styled(motion.div)(({ theme }) => ({
  backgroundSize: 'fill',
  overflow:'hidden',
  backgroundImage: 'url(/static/faqs/hero.png)',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: 500,
    padding: 0
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    position: 'absolute',
    top: theme.spacing(15)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 320,
  color: theme.palette.common.white,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': {
    backgroundColor: alpha(theme.palette.common.white, 0.04),
    [theme.breakpoints.up('md')]: {
      width: 480
    }
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

export default function FaqsHero() {
  return (
    <RootStyle initial="initial" animate="animate" variants={varWrapEnter}>
      <Helmet>
        <title>Leader in custom software development, IT services, and solutions.</title>
        <meta name="description" content="Modernize Your Technology, Redesign Your Processes. skyniche technologies assists businesses in modernizing their technology, redesigning processes, and transforming experiences to stay ahead in a rapidly evolving world." />
        <meta name="keywords" content="skyniche Technologies" />
      </Helmet>
      <Container maxWidth="lg" sx={{ position: 'relative', height: '100%' }}>
        <ContentStyle>
          <MotionInView variants={varFadeInRight}>
            <Typography component="h1" sx={{cursor:'pointer',textAlign:'left',fontSize:'42px',fontWeight:'600',color: '#fff',fontFamily: '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', }}>
              Modernize Your Technology,
              <br /> Redesign Your Processes
            </Typography>
          </MotionInView>
          <br />
          <MotionInView variants={varFadeInRight}>
            <Typography component="h2" sx={{cursor:'pointer',textAlign:'left',fontSize:'20px',fontWeight:'600',color: '#fff',fontFamily: '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', }}>
              skyniche technologies assists businesses in modernizing their technology,
              <br/> redesigning processes, and transforming experiences to 
              <br/> stay ahead in a rapidly evolving world.
            </Typography>
          </MotionInView>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
